const ContainerSize = ({ children, className = "" }) => {
  return (
    <div className={`mx-auto px-4 max-w-screen-xl w-full ${className}`}>
      {children}
    </div>
  );
};

export default ContainerSize;


